import Link from 'next/link';
import { RefObject } from 'react';
import { z } from 'zod';

import { postObjectSchema } from '~/lib/api/fragments/post-object';
import routeGenerator from '~/lib/api/routes';

interface Props extends React.AnchorHTMLAttributes<HTMLAnchorElement> {
  item: z.infer<typeof postObjectSchema>['postObject'];
  className?: string;
  ref?: RefObject<HTMLAnchorElement | null>;
}

const PageLink: React.FC<Props> = ({ item, className, children, ...rest }) => {
  if (item && item.node) {
    const { node } = item;

    switch (node.__typename) {
      case 'Page': {
        return (
          <Link
            href={routeGenerator.pageByUri({ uri: node.uri || '/' })}
            className={className}
            {...rest}
          >
            {children}
          </Link>
        );
      }

      case 'Property': {
        const category = node.propertyTypes.edges.at(0)?.node?.slug;

        if (category) {
          return (
            <Link
              href={routeGenerator.property({
                category,
                slug: node.slug,
              })}
              className={className}
              {...rest}
            >
              {children}
            </Link>
          );
        } else {
          return null;
        }
      }

      case 'Post': {
        if (node.slug) {
          return (
            <Link
              href={routeGenerator.post({
                category: node.categories.edges.map(
                  (category) => category.node.slug
                )[0],

                slug: node.slug,
              })}
              className={className}
              {...rest}
            >
              {children}
            </Link>
          );
        } else {
          return null;
        }
      }

      default: {
        return null;
      }
    }
  }

  return null;
};

export default PageLink;
